var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.15828,
    y: 0.15825,
    width: 23.0168,
    height: 15.6835,
    rx: 1.74075,
    fill: "white",
    stroke: "#F6F6F4",
    strokeWidth: 0.3165
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08357 10.8388H5.67002L4.61003 6.7949C4.55972 6.60888 4.45289 6.44443 4.29576 6.36692C3.9036 6.17214 3.47147 6.01712 3.00006 5.93894V5.78325H5.27718C5.59145 5.78325 5.82716 6.01712 5.86644 6.28874L6.41642 9.20575L7.82928 5.78325H9.20354L7.08357 10.8388ZM9.98918 10.8388H8.65421L9.75348 5.78325H11.0885L9.98918 10.8388ZM12.8156 7.1838C12.8549 6.91151 13.0906 6.75582 13.3656 6.75582C13.7977 6.71673 14.2684 6.79491 14.6613 6.98902L14.897 5.90053C14.5041 5.74484 14.072 5.66666 13.6799 5.66666C12.3842 5.66666 11.4413 6.36693 11.4413 7.33882C11.4413 8.07818 12.1092 8.46639 12.5806 8.70027C13.0906 8.93347 13.287 9.08916 13.2477 9.32236C13.2477 9.67216 12.8549 9.82785 12.4627 9.82785C11.9913 9.82785 11.5199 9.71125 11.0885 9.51646L10.8528 10.6056C11.3242 10.7997 11.8342 10.8779 12.3056 10.8779C13.7584 10.9163 14.6613 10.2167 14.6613 9.16667C14.6613 7.84431 12.8156 7.7668 12.8156 7.1838ZM19.3334 10.8388L18.2734 5.78325H17.1348C16.8991 5.78325 16.6634 5.93894 16.5849 6.17214L14.622 10.8388H15.9963L16.2706 10.1001H17.9591L18.1163 10.8388H19.3334ZM17.3313 7.1447L17.7234 9.05006H16.6241L17.3313 7.1447Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.5302c3f1ea7d427a79598adff5f599b2.svg";
export { ForwardRef as ReactComponent };